import React from 'react'

const IconeProfessor: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    height="800px"
    width="800px"
    version="1.1"
    id="_x32_"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <path
        fill="#000000"
        d="M462.277,306.305v-84.362h-9.334c-39.53,0.008-74.723,6.847-103.747,15.651
            c-5.69-11.507-12.261-23.387-17.891-33.162c24.955-21.296,40.8-52.956,40.8-88.327C372.104,51.978,320.119,0,256,0
            c-64.12,0-116.105,51.978-116.105,116.105c0,35.372,15.845,67.032,40.8,88.327c-5.63,9.775-12.201,21.655-17.891,33.162
            c-29.024-8.804-64.217-15.644-103.74-15.651h-9.334v84.362c-28.174,0.553-38.941,23.782-38.941,52.374s10.767,51.821,38.941,52.366
            v67.152l9.005,0.314l0.262,0.008c2.8,0.112,28.479,1.21,63.261,5.868c34.774,4.645,78.672,12.896,117.657,27.053l1.546,0.56h29.076
            l1.546-0.56c40.248-14.62,85.721-22.931,121.003-27.494c17.637-2.285,32.735-3.651,43.399-4.436
            c5.331-0.395,9.542-0.649,12.425-0.799c1.434-0.074,2.538-0.127,3.27-0.157c0.373-0.014,0.642-0.03,0.821-0.036l0.269-0.008
            l9.005-0.314v-67.152c28.166-0.545,38.933-23.774,38.933-52.366S490.442,306.858,462.277,306.305z M230.746,488.628
            c-37.895-12.052-77.694-19.063-109.429-23.185c-23.402-3.039-42.398-4.48-52.927-5.115v-52.314
            c20.251-7.243,34.745-26.59,34.745-49.334c0-22.745-14.494-42.092-34.745-49.342v-68.592c48.618,1.396,90.06,13.493,119.809,25.604
            c15.808,6.436,28.307,12.866,36.797,17.66c2.196,1.232,4.107,2.352,5.75,3.345V488.628z M268.813,492.817
            c-0.5,0.171-1,0.343-1.5,0.522h-22.625c-0.501-0.179-1.001-0.351-1.501-0.522V293.47h25.626V492.817z M443.609,309.337
            c-20.25,7.25-34.737,26.597-34.737,49.342c0,22.744,14.486,42.092,34.737,49.334v52.314c-10.529,0.635-29.524,2.076-52.926,5.115
            c-31.735,4.122-71.527,11.133-109.429,23.185V287.354c8.116-4.876,22.998-13.097,43.294-21.304
            c29.689-12.014,70.855-23.924,119.062-25.306V309.337z"
      />
    </g>
  </svg>
)

export default IconeProfessor
